import React from 'react'
import '../CSS/Footer.css'
const Footer = () => {
    return (
        <>
        <div className="footer">
           &#169; Made With ❤️ by Suprodip Kundu,2021.
        </div>
        </>

    )
}

export default Footer
